import React from "react";
import { CheckboxSelect, RadioSelect } from "@atlaskit/select";
import Badge from "@atlaskit/badge";
import { camelToTitle } from "../../../helpers/helpers";

const SelectDropdown = ({
  inputId,
  defaultValue,
  placeholder,
  selectLabel,
  optionData,
  onEventChange,
  onInputBlur,
  selectType,
  disabled,
  selectedValue,
}) => {
  const MultiValue = ({ getValue, index }) => {
    const otherCount = getValue().length - 1;
    const BadgeNumber =
      otherCount > 0 ? <Badge appearance="primary"> +{otherCount} </Badge> : "";
    const display = `${getValue()[getValue().length - 1].label}`;
    return (
      !index && (
        <>
          <strong>
            {camelToTitle(inputId)} : {display}
            &nbsp; {BadgeNumber}
          </strong>
        </>
      )
    );
  };

  const brandColor = "#253858";
  const textColor = "#F4F5F7";

  const SingleValue = (props) => <strong>Interval : {props.data.label}</strong>;

  const CustomStyle = (val) => {
    return {
      control: (base) => ({
        ...base,
        backgroundColor:
          val && val.length !== 0 ? brandColor : base.backgroundColor,
        borderRadius: "4px",
        borderWidth: "2px",
        height: "2.28571em",

        ":active": {
          backgroundColor:
            val && val.length !== 0 ? brandColor : base.backgroundColor,
          borderColor: "#2684FF",
          borderRadius: "3px",
          borderWidth: "2px",
        },
        ":hover": {
          backgroundColor:
            val && val.length !== 0 ? brandColor : base.backgroundColor,
        },
      }),
      singleValue: (base) => ({
        ...base,
        color: val ? textColor : base.backgroundColor,
      }),
      multiValue: (base) => ({
        ...base,
        color: val ? textColor : base.backgroundColor,
      }),
      dropdownIndicator: (base) => ({
        ...base,
        color: val ? textColor : base.backgroundColor,
      }),
      valueContainer: (base) => ({
        ...base,
        color: val && val !== "" ? textColor : base.backgroundColor,
      }),
      input: (base) => ({
        ...base,
        width: "max-content",
      }),
      menu: (base) => ({
        ...base,
        width: "max-content",
        minWidth: "150px",
      }),
    };
  };

  return (
    <>
      <label htmlFor="multi-select-example">
        <strong>{selectLabel}</strong>
      </label>
      {selectType === "checkbox" ? (
        <CheckboxSelect
          inputId={inputId}
          isMulti
          components={{ MultiValue }}
          styles={CustomStyle(selectedValue)}
          getOptionLabel={(option) => option.label}
          getOptionValue={(option) => {
            return option.value;
          }}
          className="checkbox-select"
          classNamePrefix="react-select"
          options={optionData}
          defaultValue={defaultValue}
          placeholder={placeholder}
          onChange={(e) => onEventChange(e)}
          isDisabled={disabled}
          closeMenuOnSelect={false}
          isSearchable={false}
        />
      ) : selectType === "radio" ? (
        <RadioSelect
          inputId={inputId}
          className="radio-select"
          styles={CustomStyle(selectedValue)}
          components={{ SingleValue }}
          classNamePrefix="react-select"
          defaultValue={defaultValue}
          options={optionData}
          placeholder={placeholder}
          onBlur={onInputBlur}
          onChange={(e) => onEventChange(e)}
          isDisabled={disabled}
        />
      ) : (
        ""
      )}
    </>
  );
};
export default SelectDropdown;
